export const WebsiteIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="9"
                stroke={activeColor}
                strokeWidth="1.8"
            />

            <path
                d="M3.5 12H20.5"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />

            <path
                d="M12 3C14.5 5.5 16 8.7 16 12C16 15.3 14.5 18.5 12 21"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />

            <path
                d="M12 3C9.5 5.5 8 8.7 8 12C8 15.3 9.5 18.5 12 21"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    );
}